import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions, selectors as operationSelectors } from 'ducks/uiOperations';
import { actions as formActions, selectors as formSelectors } from 'ducks/form';
import { actions as movementActions, selectors as movementSelectors } from 'ducks/pme/Movements';

import ProductMovementEnquiry from './ProductMovementEnquiry';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  isMainMenuOpen: uiSelectors.isMainMenuOpen(state),
  selectedForm: formSelectors.selected(state),
  isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
  selectedMovement: movementSelectors.selected(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    toggleSideLookUp: uiActions.toggleProductLookUp,
    toggleBrowseLookUp: uiActions.toggleBrowseLookUp,
    changeOperationMode: operationActions.changeOperationMode,
    changeSelectedTab: uiActions.changeSelectedTab,
    getFormSchema: formActions.search,
    changeSelectedForm: formActions.setSelected,
    toggleMenuOption: uiActions.toggleMenuOption,
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
    closeMenu: uiActions.closeMainMenu,
    getMovementDetails: movementActions.getDetails,
    getMovementSummary: movementActions.getSummary,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductMovementEnquiry);
